import {AMBROSIA_URL, ATHENA_URL} from '../../helpers/auth-header'
import Axios from 'axios'
import router from '../../router'
export default {
    /**
	 *
	 * @param commit
	 * @param dispatch
	 * @param event
	 */
    SearchProduct({dispatch,commit}, e){
        let productName = e.target.searchProduct.value
        dispatch('ShowLoadingToast', {'text': 'Realizando busqueda' })
        Axios.get(ATHENA_URL + '?class=com.gofarma.olimpo.entities.Product&q='+productName)
        .then(response => {
            commit('StateAssign', {filterProducts: response.data.data})
            dispatch('AssignProducts',response.data.data)})
        .then(response =>{
            dispatch('RouterPush','/filtro')
            dispatch('CloseToast')
    })
    },

    AssignProducts({commit,state,dispatch},search){
        commit('StateAssign', {filterProducts: search})
        let categoriesStack = []
        let componentsStack = []

        search.forEach(function(element){ 
            element.categories.forEach(function (categories){
                categoriesStack.push(categories)
            })

            element.components.forEach(function(components){
                componentsStack.push(components)
            })        
        }) 
        // delete all duplicates from the array
        let categories = categoriesStack.reduce((unique, o) => {
            if(!unique.some(obj => obj.name === o.name)) {
              unique.push(o);
            }
            return unique;
        },[]);

        let component = componentsStack.reduce((unique, o) => {
            if(!unique.some(obj => obj.name === o.name)) {
              unique.push(o);
            }
            return unique;
        },[]);
        categories.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );
        component.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );
        commit('StateAssign', {filterCategories: categories})
        commit('StateAssign', {filterComponents: component})
        state.categorySlug = categoriesStack[0].slug
    },
    AssignFilters({commit},object){
            let categoriesOfResult = object.categoriesOfResults
            let componentsOfResults = object.componentsOfResults
            let filterCategories = []
            let filterComponents = []

            categoriesOfResult.forEach(function (value) {
              filterCategories.push(value)
            });

            componentsOfResults.forEach(function (value) {
                filterComponents.push(value)
              });

            let categories = categoriesOfResult.reduce((unique, o) => {
                if(!unique.some(obj => obj.name === o.name)) {
                  unique.push(o);
                }
                return unique;
            },[]);
    
            let component = componentsOfResults.reduce((unique, o) => {
                if(!unique.some(obj => obj.name === o.name)) {
                  unique.push(o);
                }
                return unique;
            },[]);
    
            categories.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );
            component.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );
            commit('StateAssign', {filterCategories: categories})
            commit('StateAssign', {filterComponents: component})
    },
     /**
	 *
	 * @param commit
	 * @param product
	 */
    ProductDetail({commit},product){
        let currentProductDetail = product
        //commit('StateAssign',{currentProductDetail: currentProductDetail})
    },

    /**
	 *
	 * @param dispatch
	 * @param productId
	 */
    AddToFavorite({dispatch},productId){
        let postData = {
            productId: productId
        }
        Axios.post(AMBROSIA_URL+'/web/add-to-favorite',postData)
        .then(
            dispatch('ShowToast', { 'icon':'success', 'text': 'Se agrego producto a botiquín' })
        )
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'error', 'text': 'Ocurrio un error al agregar producto' })
        })
    },

     /**
	 *
	 * @param commit
	 * @param state
	 */
    GetHomeProducts({commit, dispatch}){
        Axios.get(AMBROSIA_URL+'/web/products/home')
        .then(response => 
            commit('StateAssign', {homeProducts: response.data.data}))    
        .catch(error => {
             dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': 'Ocurrio un error al mostrar productos' })
         })
    },

    /**
     * 
     * @param  dispatch 
     */
    GetCategories({dispatch}){
        Axios.get(AMBROSIA_URL+'/global/entities?className=Category')
        .then( response =>
             dispatch("FilterCategories",response.data))
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Ocurrio un error al filtrar productos'})
        })      
    },

    /**
     * 
     * @param commit 
     * @param fullCategories
     * 
     */
    FilterCategories({ commit, state }){
        let filter = state.categories.filter(function(categories){
            return categories.searchable == true && categories.subcategories.length != 0
        })
        commit('StateAssign', {categories:filter})
    },

    /**
     * 
     * @param dispatch
     * @param commit 
     * @param state
     * @param slug
     */
    SearchByCategory({commit,dispatch,state},slug){
        state.categorySlug = slug
        state.closeToast = false
        state.narrowMenu = false
        dispatch('ShowLoadingToast', {'text': 'Realizando busqueda' })
        Axios.get(AMBROSIA_URL+'/web/products/category/'+slug)
        .then(response =>{
            commit('StateAssign', {filterProducts: response.data.data.products})
            dispatch('AssignFilters',response.data.data)
           
        })
        .then(response => {
            dispatch('CloseToast')
            dispatch('RouterPush','/filtro')
        })
        .catch(error =>{
            dispatch('ShowToast', { 'icon':'error', 'title':'Ocurrio un error en la busqueda'})
        })
    },


    /**
     * 
     * @param dispatch
     * @param commit 
     * @param state
     * @param slug
     */
    FilterProduct({state,commit,dispatch},{key,filter,productSlug}){
        state.showFilterMenu = false
        dispatch('ShowLoadingToast', {'text': 'Aplicando filtro' })
        let slug 
        if(productSlug){
            slug = productSlug
            state.categorySlug = productSlug
        }else{
            slug = state.categorySlug
        }
        switch(key){
            case 'category':
                state.filterParams = {category: filter}
            break;
            case 'component':
                state.filterParams = {component:filter}
             
            break;
            case 'sortBy':
                state.filterParams = {sortBy:filter}
            break;
            case 'prescription':
                state.filterParams = {prescription:filter}
            break;
            case 'type':
                state.filterParams = {type: filter}
            break;
        }
        let filterParams = filterParams = JSON.parse(JSON.stringify(state.filterParams))
        
        Axios.get(AMBROSIA_URL+'/web/products/category/'+slug,{params :filterParams })
        .then(response =>{
            commit('StateAssign', {filterProducts: response.data.data.products})
            dispatch('AssignFilters',response.data.data)
        })
        .then(response => {
            dispatch('CloseToast')
            state.filterIndex = false
            state.narrowMenu = false
            dispatch('RouterPush','/filtro')
        })
        .catch(error =>{
            dispatch('ShowToast', { 'icon':'error', 'title':'Ocurrio un error aen el filtrado '})
        })
    },
    GetProductBySlug({state,dispatch},e){
        dispatch('ShowLoadingToast', {'text': 'Cargando producto' })
        Axios.get(`${AMBROSIA_URL}/web/products/${e}`)
        .then(response =>{
            state.currentProductDetail = response.data.data
        }).then(response =>{
            dispatch('CloseToast')
            router.push({ name: 'detalle', params: { slug: e } })
        })
        .catch(error =>{
            dispatch('CloseToast')
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': 'Error al encontrar producto' })
        })
    }
}
